import { LOG_OUT } from "../login/action";
import { SET_THEME } from "./action";

export const defaultState={
   selectedTheme:"light"
}

function ConfigReducer(state=defaultState,action){
    switch (action.type) {
       case SET_THEME:
          return{
              ...state,
            selectedTheme:action.payload
          }
        case LOG_OUT:
            return defaultState
        default:
          return state;
      }
}

export default ConfigReducer;